import { render, staticRenderFns } from "./FpSimpleTreeItem.vue?vue&type=template&id=b682064c&lang=pug&"
import script from "./FpSimpleTreeItem.vue?vue&type=script&lang=js&"
export * from "./FpSimpleTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports